import update from 'react-addons-update';
import { createAction, handleActions } from 'redux-actions';

import {
  IHeaderBidderParamOption,
  IPublisher,
  ISite,
  IUINotice,
  IUser,
} from '~/src/dash/api/console-api';
import { IPermissionsTemplate } from '~/src/dash/api/permissions/model';

export interface IUserState {
  user: IUser;
  publisher: IPublisher;
  sites: ISite[];
  uiNotices: IUINotice[];
  permissionTemplate: IPermissionsTemplate;
  bidderParameters: Record<string, IHeaderBidderParamOption[]>;
}

const initialState: IUserState = {
  user: undefined,
  publisher: undefined,
  sites: undefined,
  uiNotice: [] as IUINotice[],
  permissionTemplate: undefined,
  bidderParameters: undefined,
} as any;

const ACT_USER_SET = 'ACT_USER_SET_USER';
const ACT_USER_RESET = 'ACT_USER_RESET';

export const USER_ACTIONS_SET = createAction(ACT_USER_SET);

export const userReducers = handleActions(
  {
    [ACT_USER_SET]: (state: IUserState, action: any) => {
      return update(state, {
        $merge: action.payload,
      });
    },
    [ACT_USER_RESET]: (state: IUserState, action: any) => {
      return update(state, {
        $set: Object.assign({}, initialState, action.payload),
      });
    },
  },
  initialState,
);
